
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lt/sub/pamokos",
      function () {
        return require("private-next-pages/lt/sub/pamokos.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lt/sub/pamokos"])
      });
    }
  